/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

// Common constants
export const ACTIONS = {
  VIEW: 'view',
  TAP: 'tap',
  CLICK: 'click',
  TRACK_EVENT_NO_ECOMMERCE: 'trackEventNoEcommerce',
};

export const SCREEN_NAME = {
  snapSearchPage: 'SNAP Search Page',
};

export const LINE_OF_BUSINESS = {
  snap: 'SNAP',
};

// Custom Event Names
export const EVENT_NAMES = {
  TAP: 'tap',
  VIEW: 'view',
  SEARCH_WIDGET_VIEWED: 'aa_snp_searchwidget_viewed',
  SEARCH_BUTTON_CLICKED: 'aa_snp_search',
  LAST_SEARCHED_VIEWED: 'aa_snp_lastsearched_viewed',
  LAST_SEARCHED_CLICKED: 'aa_snp_lastsearched_clicked',
  CHINA_DISCLAIMER_VIEWED: 'view',
  //BANNER_VIEW: 'aa_snp_banner_viewed',
  //BANNER_TAP: 'aa_snp_banner_tapped',
  //TRIP_TYPE_TAP: 'aa_snp_triptype_tapped',
};

// SNAP Banner specific constants
export const SNAP_BANNER = {
  CATEGORY: 'SNAP|herobanner',
};

// SNAP Banner interfaces
export interface BannerViewParams {
  bannerName: string;
  position: number;
}

export interface BannerTapParams {
  bannerName: string;
  position: number;
}

// Trip Type Tab interface
export interface TripTypeTabParams {
  tripType: 'roundtrip' | 'oneway';
}

// Search Button Click interface
export interface SnapSearchButtonParams {
  departdate: string;
  returndate: string;
  checkindate: string;
  checkoutdate: string;
  currency: string;
  originairport: string;
  destinationairport: string;
  origincountry: string;
  destinationcountry: string;
  journeytype: string;
  flighttype: string;
  rooms: string;
  totalpax: number;
  lengthofstay: string;
  adult: string;
  kid: string;
  infant: string;
  coupon: string;
}

// Last Searched Viewed interface
export interface SnapLastSearchedViewedParams {
  flightRoute: string;
  position: number;
}

// Last Searched Viewed constants
export const LAST_SEARCHED_VIEWED = {
  CATEGORY: 'SNAP|snapsearchwidget',
  ACTION: 'aa_snp_lastsearched_viewed',
};

// Last Searched Clicked interface
export interface SnapLastSearchedClickedParams {
  flightRoute: string;
  position: number;
}

// Last Searched Clicked constants
export const LAST_SEARCHED_CLICKED = {
  CATEGORY: 'SNAP|snapsearchwidget',
  ACTION: 'aa_snp_lastsearched_clicked',
};

export const SELECT_DIFFERENT_DATES = {
  CATEGORY: 'SNAP|snapsearchwidget',
  DIFFERENT_DATES_TICK: 'partialhotel|tick',
  DIFFERENT_DATES_UNTICK: 'partialhotel|untick',
};

// SNAP Search Widget tracking constants
export const SNAP_SEARCH_WIDGET = {
  CATEGORY: 'SNAP|snapsearchwidget',
  LINE_OF_BUSINESS: 'SNAP',
  SCREEN_NAME: 'SNAP Search Page',
  VALUE_SEPARATOR: '|',
};

export const SNAP_SEARCH_WIDGET_USW = {
  CATEGORY: 'SNAP SA|USW',
  LABELS: 'SNAP Widget Exposed',
};

// China Disclaimer Viewed interface
export interface SnapChinaDisclaimerViewedParams {
  disclaimerMessage: string;
}

// China Disclaimer Viewed constants
export const CHINA_DISCLAIMER_VIEWED = {
  CATEGORY: 'SNAP|CN disclaimer',
  LINE_OF_BUSINESS: 'SNAP',
};
